/**
 * Communication Tab
 *
 * Renders the internal communication chat for a customer. The customer
 * onboarding audit-log feed was removed along with the onboarding module;
 * this tab now surfaces the internal communication panel only.
 */

import { Card, CardContent } from '../../components/ui/card';
import { CustomerProfile } from '../../lib/api';
import { ChatPanel } from './ChatPanel';

interface ActivityTabProps {
  customer: CustomerProfile;
}

export function ActivityTab({ customer }: ActivityTabProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <ChatPanel customer={customer} />
      </CardContent>
    </Card>
  );
}
